export const AVATAR_STATUSES = {
    approved: 'APPROVED',
    pending: 'PENDING',
    rejected: 'REJECTED'
  };